export default __webpack_public_path__ + "static/media/user-check.d0b4227a.svg";